import { useEffect } from "react";
import { withStyles, Divider, Grid } from "@material-ui/core";
import { compose } from "recompose";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import { trackEvent } from "../../../../common/AppInsightsEventTracking";
import styles from "./styles";
import WithDrawer from "../../../Dispatch/Common/Drawer/WithDrawer";
import { DeliveryStopMergeForm, PickupStopMergeForm } from "./components";
import { getDataWithQueryString } from "../../../../../api/componentAPIs";

const MergeStops = (props) => {
  const {
    classes,
    selectedStops,
    mergeType,
    isPickupStopMergeFlow = false,
    userData,
    glEventHub,
    onClose,
    onMergeCompleted,
  } = props;

  useEffect(() => {
    trackMergeActions("DialogOpened");
  }, []);

  const trackMergeActions = (eventType, requestData) => {
    trackEvent("MergeStops", userData.userProfile, {
      eventType,
      selectedStops: selectedStops,
      mergeStopInfo: requestData,
    });
  };

  //used to fetch customer as well as shipper data
  const fetchCustomerData = (customerCodes) => {
    return getDataWithQueryString(
      "GetCustomerDetail",
      `terminalId=${
        userData.userProfile.terminal.id
      }&customerCodes=${customerCodes.join(",")}`
    )
  }

  return (
    <div className={classes.container}>
      <Divider className={classes.divider} />
      <Grid item xs={12} className={classes.head}>
        Merge Stops
      </Grid>
      <Divider className={classes.divider} />
      <div className={classes.contentContainer}>
        {isPickupStopMergeFlow ? (
          <PickupStopMergeForm
            classes={classes}
            selectedStops={selectedStops}
            mergeType={mergeType}
            userData={userData}
            trackMergeActions={trackMergeActions}
            glEventHub={glEventHub}
            onClose={onClose}
            onMergeCompleted={onMergeCompleted}
            fetchCustomerData={fetchCustomerData}
          />
        ) : (
          <DeliveryStopMergeForm
            classes={classes}
            selectedStops={selectedStops}
            mergeType={mergeType}
            userData={userData}
            trackMergeActions={trackMergeActions}
            glEventHub={glEventHub}
            onClose={onClose}
            onMergeCompleted={onMergeCompleted}
            fetchCustomerData={fetchCustomerData}
          />
        )}
      </div>
    </div>
  );
};

export default compose(
  WithDrawer,
  withStyles(styles),
  withUserProfile
)(MergeStops);
